<template>
  <div>
    <v-dialog v-model="dialog" max-width="700px" scrollable persistent>
      <v-card>
        <v-toolbar dense color="primary" dark>
          <v-toolbar-title
            >Exportar acta de inventario por área</v-toolbar-title
          >
          <v-spacer />
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                class="mx-2 my-2"
                text
                fab
                small
                v-on="on"
                @click.stop="close"
              >
                <v-icon>fa-times</v-icon>
              </v-btn>
            </template>
            <span>Cerrar</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <v-form v-model="valid" ref="formExport" @submit.prevent="save">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="editedItem.costcenter_id"
                    item-value="id"
                    item-text="name"
                    :items="allCostCenters"
                    id="searchFormType"
                    label="* Centro de costos"
                    placeholder="Seleccione el centro de costos"
                    required
                    clearable
                    :rules="rules.generalRequired"
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12">
                  <v-autocomplete
                    v-model="editedItem.area_id"
                    item-value="id"
                    item-text="name"
                    :items="allAreas"
                    id="searchFormType"
                    label="* Área"
                    placeholder="Seleccione el área"
                    required
                    clearable
                    :rules="rules.generalRequired"
                  ></v-autocomplete>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.person_delivers1_id"
                    label="* Documento de la persona 1 que entrega"
                    placeholder="Ingrese el documento"
                    required
                    :rules="rules.generalRequired"
                    clearable
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.person_delivers2_id"
                    label="Documento de la persona 2 que entrega"
                    placeholder="Ingrese el documento"
                    clearable
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.person_receives_id"
                    label="* Documento de la persona que recibe"
                    placeholder="Ingrese el documento"
                    :rules="rules.generalRequired"
                    clearable
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="editedItem.boss_id"
                    label="Documento del Jefe"
                    placeholder="Ingrese el documento"
                    clearable
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary " @click="close">Cancelar</v-btn>
          <v-btn color="primary " @click="save" :loading="loading"
            >Generar acta</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"; // Ensure vuex types are installed
import { URL_APP } from "../../../util/constants";
import { createLinkFile } from "../../../util/functions";

export default {
  name: "ExportInventoryForUser",
  data() {
    return {
      editedItem: { identification: null },
      defaultItem: { identification: null },
      dialog: false,
      valid: true,

      rules: {
        generalRequired: [(v) => !!v || "El campo es requerido"],
      },
    };
  },

  computed: {
    ...mapGetters([
      "loading",
      "updateAssetThird",
      "allAreas",
      "allCostCenters",
    ]),
  },

  methods: {
    ...mapActions([
      "chgLoad",
      "getAssetThirdByIdentification",
      "getAreas",
      "getCostCenters",
    ]),
    async openDialog() {
      this.chgLoad(true);
      await Promise.all([this.getAreas(), this.getCostCenters()]);
      this.chgLoad(false);

      this.dialog = true;
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
      }, 300);
    },

    async save() {
      if (!this.$refs.formExport.validate()) return; // Validar formulario antes de enviar

      this.chgLoad(true);
      try {
        const url = URL_APP + "/api/loan_assets/export_record";
        const response = await this.$http.get(url, {
          params: this.editedItem,
          responseType: "blob", // Esto causa que el error venga como Blob
        });

        createLinkFile(response);
        this.$root.$alert({
          text: "Descarga exitosa",
          color: "success",
          timeout: 2000,
        });

        this.close();
      } catch (error) {
        console.log(error);
        let message = "Error al descargar el archivo";

        if (error.response && error.response.data) {
          // 1. Verificamos si la respuesta es un Blob (lo usual por el responseType)
          if (error.response.data instanceof Blob) {
            try {
              // Leemos el texto del blob y lo parseamos a JSON
              const text = await error.response.data.text();
              const json = JSON.parse(text);

              if (json.message) {
                message = json.message;
              } else if (json.errors) {
                message = Object.values(json.errors).join("\n");
              }
            } catch (e) {
              console.error("Error al parsear el error del blob:", e);
            }
          }
          // 2. Por si acaso axios no lo convirtió a Blob (fallback)
          else {
            if (error.response.data.message) {
              message = error.response.data.message;
            } else if (error.response.data.errors) {
              message = Object.values(error.response.data.errors).join("\n");
            }
          }
        }

        this.$root.$alert({
          text: message,
          color: "error",
          timeout: 4000,
        });
      }
      this.chgLoad(false);
    },
  },
};
</script>

<style lang="scss" scoped></style>
